/* istanbul ignore file */
import React, { MouseEventHandler, useEffect } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { v4 as uuidV4 } from 'uuid';
import { toast } from 'react-toastify';
import moment from 'moment';
import { get, uniqueId, isEmpty } from 'lodash';
import SahamDrawer from 'components/SahamDrawer';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { constructOldAssignement } from 'containers/CourtManagerAssignedExpertise/utils';
import { ContainerInDrawer } from 'containers/LawyerFeeNote/styled-components';
import AssignExpertForm from 'containers/CourtManagerLegalProceedings/AssignExpert';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import * as util from 'containers/RecapManagerPage/utils';
import { LISTINGS } from 'containers/data-structure';
import { SagisConfig } from 'containers/AppContainer/typings';
import SahamDialog from 'components/SahamDialog';
import { ITEM_KEYS, SAGIS_KEYS } from 'containers/RecapManagerPage/constants';
import { resolveExpertiseType } from 'containers/CourtManagerLegalProceedings/utils';
import {
  extractCourtFileNumber,
  returnDefaultCodeByType,
} from 'containers/CourtManagerLegalProceedings/AssignExpert/utils';
import currentUserStorage from 'containers/services/security/current-user-storage';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';

export interface UpdateMissionDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleToggleDrawer: Function;
  listings: any;
  victims: any;
  uploadDocument: Function;
  mission: any;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  setDocumentId: Function;
  documentId: string;
  claimId: number;
  claimNumber: string;
  judiciaryProcessId: number;
  courtFileNumber: string;
  requestCorporealLawyers: Function;
  corporealLawyers: any;
  assignedLawyer: any;
  searchQuery: any;
  civilProceeding: any;
  corporealExperts: any;
  requestGetExpertUsers: Function;
  requestUpdateMission: Function;
  vehicles: any;
  riskKey: string;
}

const UpdateMissionDrawer: React.FC<UpdateMissionDrawerProps> = (
  props,
): JSX.Element => {
  const [assignExpert, setAssignExpert] = React.useState({
    ...props.mission,
    step: props.mission?.stepId,
    hour: props.mission?.lossHour,
    missionDate: moment(props.mission.missionDate, 'DD/MM/YYYY').format(
      'YYYY-MM-DD',
    ),
    assignedExperts: props.mission?.assignedExpert,
    city: props.mission?.cityCode,
    receiptDate: moment(props.mission.receiptDate, 'DD/MM/YYYY').format(
      'YYYY-MM-DD',
    ),

    lawyer: props.assignedLawyer,
  });
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);
  const [invitationDoc, setInvitationDoc] = React.useState<null | any>({});
  const [stakeholders, setStakeholders] = React.useState([] as SagisConfig[]);
  React.useEffect(() => {
    props.requestGetExpertUsers(
      resolveExpertiseType(Number(props.mission?.type)),
    );
  }, [props.mission]);

  React.useEffect(() => {
    const _stackholders = util.getListBySagisKey(
      get(props.listings, LISTINGS.STACKHOLDER_TYPE, []),
      get(props.listings, LISTINGS.STACKHOLDERS, []),
      ITEM_KEYS.LAWYER,
      SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
    );

    const lawyers = util.getBawabaLawyers(
      _stackholders,
      props.corporealLawyers,
    );
    setStakeholders(lawyers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.listings]);
  useEffect(() => {
    if (!isEmpty(props.mission)) {
      setAssignExpert({
        ...props.mission,
        step: props.mission?.stepId,
        hour: props.mission?.lossHour,
        missionDate: moment(props.mission.missionDate, 'DD/MM/YYYY').format(
          'YYYY-MM-DD',
        ),
        assignedExperts: props.mission?.assignedExpert,
        city: props.mission?.cityCode,
        receiptDate: moment(props.mission.receiptDate, 'DD/MM/YYYY').format(
          'YYYY-MM-DD',
        ),
      } as any);
      setInvitationDoc(props.mission?.document);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.mission]);

  const successCallBack = () => {
    toast.success(translate(messages.titleUpdateSuccess, props));
    props.handleToggleDrawer();
  };
  const correctionnelProceeding = props.civilProceeding?.filter(
    (element: { procedureNatureId: number }) => element.procedureNatureId === 3,
  );

  const handleValidation = () => {
    const assignement = constructOldAssignement(
      get(props.mission, 'assignedExpert'),
      get(assignExpert, 'assignedExperts'),
      get(props.mission, 'id'),
    );
    props.requestUpdateMission(
      {
        ...assignExpert,
        document: {
          ...invitationDoc,
          isIndexed: false,
          uploadedBy: currentUserStorage.get().username,
        },
        missionDate:
          get(assignExpert, 'missionDate') === '' ||
          get(assignExpert, 'missionDate') === 'Invalid date'
            ? null
            : get(assignExpert, 'missionDate'),
        receiptDate:
          get(assignExpert, 'receiptDate') === '' ||
          get(assignExpert, 'receiptDate') === 'Invalid date'
            ? null
            : get(assignExpert, 'receiptDate'),
        victims: get(assignExpert, 'victims', []).map((el: any) => el.id),
        vehicles: get(assignExpert, 'vehicles', []).map((el: any) => el.id),
        assignement: assignement,
        intervenantSagis: !isEmpty(
          assignement.filter((el: any) => !el.isForDelete && !el.id),
        )
          ? assignement
              .filter((el: any) => !el.isForDelete && !el.id)
              .map((element: any) => ({
                intervenantTypeCode: returnDefaultCodeByType(
                  Number(get(assignExpert, 'type')),
                ),
                intervenantCode: element.expertCode,
              }))
          : [],
        excludedIntervenant: !isEmpty(
          assignement.filter((el: any) => el.isForDelete),
        )
          ? assignement
              .filter((el: any) => el.isForDelete)
              .map((element: any) => element.expertCode)
          : [],
        assignementDetails: {
          contractorFees: assignement
            .filter((el: any) => !el.isForDelete && !el.id)
            .map((element: any) => ({
              uniqueId: uniqueId(),
              contractorTypeCode: returnDefaultCodeByType(
                Number(get(assignExpert, 'type')),
              ),
              contractorCode: element.expertCode,
              amount: 0,
              isPayment: false,
            })),
          uuid: uuidV4(),
        },
        courtFileNumber: get(assignExpert, 'judiciaryProcessId')
          ? extractCourtFileNumber(
              props.civilProceeding,
              get(assignExpert, 'judiciaryProcessId'),
            )
          : props.courtFileNumber,
        claimId: props.claimId,
        id: props.mission.id,
        claimNumber: props.claimNumber,
        reference: props.mission.missionNumber,
        judiciaryProcessId:
          String(get(assignExpert, 'procedureNatureId', null)) === '3'
            ? get(correctionnelProceeding, '[0].id')
            : get(assignExpert, 'judiciaryProcessId'),
        procedureNatureId: String(get(assignExpert, 'procedureNatureId', null)),
        username: currentUserStorage.get().username,
        updatedBy: currentUserStorage.get().username,
        riskKey: props.riskKey,
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
      },
      successCallBack,
    );
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };
  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };
  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={props.handleToggleDrawer}
      title={translate({ ...messages.ExpertUpdateDrawerTitle }, props, {
        number: null,
      })}
      handleValidateDrawer={handleOpenDialog}
      confirmButtonTitle={translate(messages.UpdateButtonTitle, props)}
      isSaveButtonDisabled={!invitationDoc?.url || !invitationDoc?.type}
    >
      <ContainerInDrawer>
        <AssignExpertForm
          assignExpert={assignExpert}
          listings={props.listings}
          setAssignExpertFields={setAssignExpert}
          victims={props.victims}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          resetUploadedDocument={props.resetUploadedDocument}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          invitationDoc={invitationDoc}
          stakeholders={stakeholders}
          corporealLawyers={props.corporealLawyers}
          setInvitationDoc={setInvitationDoc}
          corporealExperts={props.corporealExperts}
          requestGetExpertUsers={props.requestGetExpertUsers}
          selectedVictim={[props.mission?.victims[0]?.id]}
          document={props.mission?.document}
          vehicles={props.vehicles}
          civilProceeding={props.civilProceeding}
          selectedVehicle={[props.mission?.vehicles[0]?.id]}
          isUpdate={true}
        />
      </ContainerInDrawer>
      <SahamDialog
        handleValidate={handleValidation}
        handleClose={handleCloseDialog as MouseEventHandler}
        title={translate(messages.courtManagerConfirmationDialogTitle, props)}
        cancelTitle={translate(
          messages.courtManagerConfirmationDialogCancel,
          props,
        )}
        confirmTitle={translate(
          messages.courtManagerConfirmationDialogConfirm,
          props,
        )}
        open={isDialogOpen}
      >
        {translate(messages.courtManagerConfirmationDialogContent, props)}
      </SahamDialog>
    </SahamDrawer>
  );
};

export default injectIntl(UpdateMissionDrawer);
